import cx from "classnames"
import * as styles from "./styles.module.scss"
import * as React from "react"
import { useInView } from "react-intersection-observer"

interface IProps {
  badge?: string
  heading: string | React.ReactNode
  number: string
  subhead?: string
}

const Item = ({ badge, heading, number, subhead }: IProps) => {
  const [ref, inView, entry] = useInView({ threshold: 0 })

  return (
    <li
      className={cx({
        [styles.item]: true,
        [styles.inView]: inView && entry && entry.intersectionRect.top > 0,
      })}
      ref={ref}
    >
      <div className={styles.numberDisk}>
        <div className={styles.number}>{number}</div>
      </div>
      <div className={styles.step}>
        {badge && <div className={styles.badge}>{badge}</div>}
        <h4 className={styles.stepHeading}>{heading}</h4>
        <span className={styles.stepSubhead}>{subhead}</span>
      </div>
    </li>
  )
}

export default Item
